import { Separator } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Container } from '@/components/ui/container'
import { Text } from '@/components/ui/typography'
import Source from '@/pages/components/chat/components/source'
import { ICitation as CitationProps } from '@/types/gigiChat/Conversation'

const Sources = ({ citations }: { citations: Array<CitationProps> }) => {
    const { t } = useTranslation()
    if (!citations || !citations.length) {
        return null
    }

    const getSources = (maxNumberToRender?: number) => {
        if (!citations) {
            return null
        }
        return citations.map((item: CitationProps, index: number) => {
            if (maxNumberToRender && index > maxNumberToRender) return null
            if (!item.name) return false
            return <Source text={item.name} link={item.url} key={item.name + index.toString()} />
        })
    }

    return (
        <>
            <Container variant="citations" maxWidth="unset" data-testid="chat-sources">
                <Separator variant="citations" />
                <Box display="inline-block" mt="12px">
                    <Text position="relative" display="inline-block" fontSize="14px" lineHeight="24px" top="-3px">
                        {t('chat.sources.title')}
                    </Text>
                    {getSources()}
                </Box>
            </Container>
        </>
    )
}

export default Sources
